import { getI18n } from 'react-i18next';

export const ERROR_CLEARING_HOUSE_NOT_FOUND = 'clearingHouse.notFound';
export const ERROR_CLEARING_HOUSE_CANT_BE_DELETED = 'clearingHouse.noDelete';
export const VALIDATION_CLEARING_HOUSE_LIVE_AUCTION = 'validation.clearingHouse.liveAuction';
export const VALIDATION_CLEARING_HOUSE_EMPTY_CODE = 'validation.clearingHouse.emptyCode';
export const VALIDATION_CLEARING_HOUSE_INVALID_CODE_LENGTH = 'validation.clearingHouse.invalidCodeLength';
export const VALIDATION_CLEARING_HOUSE_INVALID_CODE = 'validation.clearingHouse.invalidCode';
export const VALIDATION_CLEARING_HOUSE_EMPTY_NAME = 'validation.clearingHouse.emptyName';
export const VALIDATION_CLEARING_HOUSE_INVALID_NAME_LENGTH = 'validation.clearingHouse.invalidNameLength';
export const VALIDATION_CLEARING_HOUSE_EMPTY_TIME_ZONE = 'validation.clearingHouse.emptyTimeZone';
export const VALIDATION_CLEARING_HOUSE_INVALID_TIME_ZONE = 'validation.clearingHouse.invalidTimeZone';
export const VALIDATION_CLEARING_HOUSE_NULL_CASH_LIMIT = 'validation.clearingHouse.nullCashLimits';
export const VALIDATION_CLEARING_HOUSE_CODE_ALREADY_IN_USE = 'validation.clearingHouse.codeAlreadyInUse';
export const VALIDATION_CLEARING_HOUSE_CASH_LIMIT_EMPTY_CURRENCY = 'validation.clearingHouse.cashLimit.emptyCurrency';
export const VALIDATION_CLEARING_HOUSE_CASH_LIMIT_INVALID_CURRENCY = 'validation.clearingHouse.cashLimit.invalidCurrency';
export const VALIDATION_CLEARING_HOUSE_CASH_LIMIT_EMPTY_CASH_LIMIT = 'validation.clearingHouse.cashLimit.emptyCashLimit';
export const VALIDATION_CLEARING_HOUSE_CASH_LIMIT_INVALID_CASH_LIMIT = 'validation.clearingHouse.cashLimit.invalidCashLimit';
export const VALIDATION_CLEARING_HOUSE_CASH_LIMIT_DUPLICATE_CURRENCY = 'validation.clearingHouse.cashLimit.duplicateCurrency';

export const createClearingHouseErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case ERROR_CLEARING_HOUSE_NOT_FOUND:
            result = i18n.t('clearing-houses.error.clearing-house-not-found');
            break;
        case ERROR_CLEARING_HOUSE_CANT_BE_DELETED:
            result = i18n.t('clearing-houses.error.clearing-house-cannot-be-deleted');
            break;
        case VALIDATION_CLEARING_HOUSE_LIVE_AUCTION:
            result = i18n.t('clearing-houses.error.clearing-house-live-auction');
            break;
        case VALIDATION_CLEARING_HOUSE_EMPTY_CODE:
            result = i18n.t('clearing-houses.error.clearing-house-empty-code');
            break;
        case VALIDATION_CLEARING_HOUSE_INVALID_CODE_LENGTH:
            result = i18n.t('clearing-houses.error.clearing-house-invalid-code-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_CLEARING_HOUSE_INVALID_CODE:
            result = i18n.t('clearing-houses.error.clearing-house-invalid-code');
            break;
        case VALIDATION_CLEARING_HOUSE_EMPTY_NAME:
            result = i18n.t('clearing-houses.error.clearing-house-empty-name');
            break;
        case VALIDATION_CLEARING_HOUSE_INVALID_NAME_LENGTH:
            result = i18n.t('clearing-houses.error.clearing-house-invalid-name-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_CLEARING_HOUSE_EMPTY_TIME_ZONE:
            result = i18n.t('clearing-houses.error.clearing-house-empty-time-zone');
            break;
        case VALIDATION_CLEARING_HOUSE_INVALID_TIME_ZONE:
            result = i18n.t('clearing-houses.error.clearing-house-invalid-time-zone');
            break;
        case VALIDATION_CLEARING_HOUSE_NULL_CASH_LIMIT:
            result = i18n.t('clearing-houses.error.clearing-house-null-cash-limit');
            break;
        case VALIDATION_CLEARING_HOUSE_CODE_ALREADY_IN_USE:
            result = i18n.t('clearing-houses.error.clearing-house-code-already-in-use');
            break;
        case VALIDATION_CLEARING_HOUSE_CASH_LIMIT_EMPTY_CURRENCY:
            result = i18n.t('clearing-houses.error.clearing-house-cash-limit-empty-currency');
            break;
        case VALIDATION_CLEARING_HOUSE_CASH_LIMIT_INVALID_CURRENCY:
            result = i18n.t('clearing-houses.error.clearing-house-cash-limit-invalid-currency');
            break;
        case VALIDATION_CLEARING_HOUSE_CASH_LIMIT_EMPTY_CASH_LIMIT:
            result = i18n.t('clearing-houses.error.clearing-house-cash-limit-empty-cash-limit');
            break;
        case VALIDATION_CLEARING_HOUSE_CASH_LIMIT_INVALID_CASH_LIMIT:
            result = i18n.t('clearing-houses.error.clearing-house-cash-limit-invalid-cash-limit');
            break;
        case VALIDATION_CLEARING_HOUSE_CASH_LIMIT_DUPLICATE_CURRENCY:
            result = i18n.t('clearing-houses.error.clearing-house-cash-limit-duplicate-currency');
            break;
        default:
            result = undefined;
    }
    return result;
};
